
import React, { Component } from 'react';
import {
    message,
    Table,
    Select,
    Drawer,
    Switch,
    Row,
    Button,
    Input,
    Form,
    Modal,
    Popconfirm,
    Tooltip,
    notification,
    Radio,
    Col,
    Divider,
    Card,
    Upload,
    Avatar,
    Typography,
    Tag,
    Slider,
    InputNumber, Badge

} from 'antd';

import { Link } from 'react-router-dom';

import {
    PlusOutlined,
    DeleteOutlined,
    ReloadOutlined,
    InfoOutlined,
    CheckOutlined,
    CloseOutlined
} from '@ant-design/icons';



import { inject, observer } from 'mobx-react';

import moment from 'moment'

import axios from "axios"

import _ from "lodash"

import { withTranslation } from 'react-i18next';
import { cdnUrl } from '../config';
import NavbarMenu from '../components/NavbarMenu';
import NavbarPanel from '../components/NavbarPanel';
import { LoadingGlobal } from '../components/LoadingGlobal';
import { toJS } from 'mobx';
import { formatMyMoney } from '../helper';

const queryString = require('query-string');

const { Search, TextArea } = Input;

const { Option } = Select;
const { Text } = Typography;



// 
@inject('UserStore')
@observer
export default class UserNetwork extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            userTypes: [
                { title: "Web Kullanıcı", value: 4 },
                { title: "Bayi", value: 3 },
                { title: "Admin", value: 2 },
                { title: "Süper Admin", value: 1 },
                { title: "Joker", value: 0 },
            ],
            workTypes: [
                { title: "Girişten", value: 0 },
                { title: "Kasadan", value: 1 },
                { title: "Kaybedenden", value: 2 },
            ],
            modalOpenCreate: false,
            credit: 0,
            percent: 25,
            workType: 1,
            page: 'balance'
        }
    }

    componentDidMount = async () => {

        const parsedHash = queryString.parse(location.search);
        const userId = _.get(parsedHash, "user")

        this.getItems(userId)
    }

    //#liste
    getItems = async (id = null) => {
        this.props.UserStore.getUsers(id);
        /*
        this.setState({ loading: true })
        try {
            let serverData = await this.props.ProductStore.getCategories("withproduct");
            console.log(_.get(serverData, "data.results"))
            this.setState({
                data: _.get(serverData, "data.results")
            })
        } catch (error) {

        }
        finally {
            this.setState({ loading: false })
        }
        */
    }

    resetState() {
        this.setState({
            _id: '',
            name: '',
            password: '',
            username: '',
            modalOpenCreate: false,
            page: 'balance'
        })
    }

    reload = () => {
        this.resetState()
        this.getItems()
    }
    //#ekle
    handleCreate = async () => {
        try {
            const sData = await this.props.UserStore.register(this.state)
            message.success()
            this.resetState()
            this.getItemList()
        } catch (error) {
            console.log({ error })
            message.error(_.get(error, "response.data.error", ""))
        }

    }

    //#sil
    confirmDelete = async (item) => {
        console.log(item)
        try {
            const serverData = await this.props.ProductStore.deleteCategory(item._id)
            console.log(serverData)
            this.state.data = _.remove(this.state.data, (o) => {
                return o._id != item._id
            })
            //  console.log({items})
            //  const dd =[]
            //  dd.splice(1)
            this.setState({ data: this.state.data })

        } catch (error) {
            console.log(error)
        }

    }

    //düzenle click
    clickEdit = (item) => {
        //   this.titleInput.focus()
        console.log(item)
        this.setState({
            ...item
        }, () => {
            this.setState({ modalOpenCreate: true })
        })
    }





    handleCancel() {
        this.resetState()
        /*
        this.setState({
          modalOpenCreate: false,
        })
      */
    }



    onChangeUserType = (e) => {
        console.log(e)
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    onChangeCredit = (e) => {
        this.setState({ credit: e })
    }

    onChangeSwitchList = async (checked, item) => {
        console.log(checked);
        console.log({ item: toJS(item) });
        message.destroy()
        try {
            const serverData = await this.props.UserStore.setActive(item._id, checked)
            // checked ? message.success() : message.error()
            console.log(serverData)

        } catch (error) {
            console.log(error)
            message.warn()
        }
    }



    onClickLimit = async (item, type) => {
        const updateData = {
            type,
            value: item[type]
        }
        console.log({ item: toJS(item), type, updateData })


        if (type == "minus" && parseInt(item.minus) > parseInt(item.balance)) {
            message.warning("Yetersiz Bakiye!")
            return
        }


        if (parseInt(item[type]) < 0) {
            message.warning("Geçersiz Giriş!")
            return
        }


        try {
            await this.props.UserStore.updateLimit(item._id, updateData)
            this.props.UserStore.updateLocalBalance(item._id, item[type])
            //  item.balance = 800
            message.success()
            //this.getItems()
            location.reload()
        } catch (error) {
            message.error(_.get(error, "response.data.message"))
        }

    }

    render() {
        const { user } = this.props.UserStore

        const activeUserType = _.get(user, "userType", 4)

        const { workTypes, page } = this.state
        const { loading } = this.props.UserStore


        let data = this.props.UserStore.users

        const { credit } = this.state;

        let userTypes = this.state.userTypes

        userTypes = _.filter(userTypes, (o) => {
            return o.value == _.get(user, "userType", 4) + 1
        })

        // kredi (online kullanıcı)
        let userCredit = _.get(user, "credit", 0)





        const handleFocus = (event) => event.target.select();




        const columns = [
            {
                title: `Kullanıcı Adı/${activeUserType == 1 ? 'kredi' : 'bakiye'}`,
                key: 'userType',
                render: (text, record) => <span>
                    {record.username}
                    {` `}  <Text type="secondary" >{record.name ? " (" : ""}
                        {record.name}
                        {record.name ? ") " : ""}

                        <Tag color='magenta'>
                            {
                                activeUserType == 1
                                    ?
                                    <b>
                                        {record.credit}
                                    </b>
                                    :
                                    <b>{formatMyMoney(record.balance)} ₺</b>
                            }
                        </Tag>
                    </Text>
                </span>
            },
            {
                title: 'Ekle',
                key: 'plus',
                render: (text, record) => <span>
                    <Input
                        onFocus={handleFocus}
                        onChange={(e) => {
                            record.plus = e.target.value
                        }}
                        name="percent"
                        type="number"
                        suffix={<span>
                            <Tooltip title={record.username}>
                                <Button
                                    onClick={() => this.onClickLimit(record, "plus")}
                                    shape="round" size="small" type="primary">Ekle</Button>
                            </Tooltip>

                        </span>}
                    />
                </span>
            },
            {
                title: 'Çıkar',
                key: 'minus',
                render: (text, record) => <span>
                    <Input
                        onFocus={handleFocus}
                        onChange={(e) => {
                            record.minus = e.target.value
                        }}
                        name="percent"
                        type="number"
                        suffix={<span>
                            <Tooltip title={record.username}>
                                <Button
                                    onClick={() => this.onClickLimit(record, "minus")}
                                    shape="round" size="small" type="primary">Çıkar</Button>
                            </Tooltip>

                        </span>}
                    />
                </span>
            },
            {
                title: 'Dengele',
                key: 'loadbalance',
                render: (text, record) => <span>
                    <Input
                        onFocus={handleFocus}
                        onChange={(e) => {
                            record.loadbalance = e.target.value
                        }}
                        name="percent"
                        type="number"
                        suffix={<span>
                            <Tooltip title={record.username}>
                                <Button
                                    onClick={() => this.onClickLimit(record, "loadbalance")}
                                    shape="round" size="small" type="primary">Dengele</Button>
                            </Tooltip>

                        </span>}
                    />
                </span>
            }
        ];



        return (
            <div>
                <NavbarPanel page="limit" />
                <LoadingGlobal loading={!user || loading} />
                <Card
                    loading={loading}
                    title={
                        <span>
                            {
                                activeUserType == 1 ? 'KREDİ ekle/çıkar' : 'BAKİYE ekle/çıkar'
                            }
                        </span>
                    }
                    extra={<span>
                        <Button type="primary"
                            shape="circle"
                            title="Yenile"
                            icon={<ReloadOutlined />}
                            style={{ marginLeft: '8px' }}
                            onClick={() => this.reload()} />
                    </span>}
                >


                    <div>

                        <Table
                            bordered={true}
                            rowKey={'_id'}
                            columns={columns}
                            pagination={false}
                            size="small"
                            dataSource={data}
                            loading={loading}
                        />
                    </div>

                </Card>
            </div>
        )
    }
}
